import { useEffect, useMemo, useRef } from "react"
import { useField } from "formik"

import {
    MeetingServicePriceListState,
    SatelliteDetails,
    SelectedMainUserState,
} from "../../../createOrderTypes"
import { useMeetingServicePriceListStatus } from "../../../hooks/useMeetingServicePriceListStatus"
import { DeliveryFulfillmentType, DynamicConfigField, DynamicConfigKey } from "../../form/formTypes"

import { mapDeliveryToSatelliteType } from "./helpers"
import { SatelliteCanteens } from "./SatelliteCanteens"

type Props = Readonly<{
    user: SelectedMainUserState
    config: DynamicConfigField
}>

export function SatelliteCanteensContainer({ user, config }: Props) {
    const [deliveryField] = useField<DeliveryFulfillmentType | null>(DynamicConfigKey.DELIVERY_TYPE)
    const [priceListField] = useField<MeetingServicePriceListState>("priceList")
    const [, , satHelpers] = useField<SatelliteDetails | null>({ name: config.key })
    const satelliteType = useMemo(() => mapDeliveryToSatelliteType(deliveryField.value), [deliveryField.value])
    const { isReady } = useMeetingServicePriceListStatus(priceListField.value.status)

    const prevType = useRef<DeliveryFulfillmentType | null>(deliveryField.value)
    useEffect(() => {
        if (prevType.current !== deliveryField.value) {
            prevType.current = deliveryField.value
            satHelpers.setValue(null, false)
        }
    }, [deliveryField.value, satHelpers])

    const enabled = Boolean(
        user.userId &&
        isReady &&
        priceListField.value.item?.merchantId &&
        satelliteType,
    )

    if (!enabled) return null

    return (
        <SatelliteCanteens
            name={config.key}
            label={config.label || ""}
            userId={user.userId}
            merchantId={priceListField.value.item!.merchantId}
            satelliteType={satelliteType!}
        />
    )
}
